import EmbeddedFormPage from './EmbeddedFormPage';

const MealLoggingPage = () => (
  <EmbeddedFormPage
    titleKey="Meal Logging"
    description="Fill out this form to turn on Meal Logging for your program. Meal Logging makes it easy to record what children eat each day and stay compliant with food program requirements."
    formUrl="https://wonderschool.fillout.com/t/uRyM7KtyT1us"
  />
);

export default MealLoggingPage;
